export default "__VITE_ASSET__DYuM67D2__"